/* Ungefragten Autofokus des Leadanizer-Funnel-Widgets neutralisieren (04.09.2026)
 *
 * Das Widget setzt beim Laden von sich aus den Fokus auf seinen eigenen Button
 * (role="button", tabindex="0"). Zusammen mit unserer Gestaltungsregel
 * :focus-visible { outline: 2px solid var(--accent-color); outline-offset: 2px }
 * entstand dadurch ohne jedes Zutun des Besuchers eine rote Linie unter und
 * rechts vom Button "Traumkueche finden" (links/oben liegt der Ring ausserhalb
 * des Sichtfensters).
 *
 * Der Fokus wird NUR entfernt, solange der Besucher selbst noch nichts getan
 * hat. Wer per Tab oder Klick dorthin navigiert, behaelt seinen Fokusring —
 * der Ring ist ein Barrierefreiheits-Merkmal und wird nicht abgeschaltet.
 */
(function () {
  var SEL = '#ldnzr-funnel-widgetContainer';
  var userActed = false;
  function mark() { userActed = true; }
  ['pointerdown', 'keydown', 'touchstart'].forEach(function (t) {
    document.addEventListener(t, mark, { capture: true, passive: true });
  });
  function inWidget(el) { return el && el.closest && el.closest(SEL); }
  document.addEventListener('focusin', function (e) {
    if (!userActed && inWidget(e.target)) { try { e.target.blur(); } catch (err) {} }
  }, true);
  function drop() {
    if (userActed) return;
    var a = document.activeElement;
    if (inWidget(a)) { try { a.blur(); } catch (err) {} }
  }
  window.addEventListener('load', drop);
  setTimeout(drop, 1500);
  setTimeout(drop, 4000);
})();
